export default {"src":"/_next/static/image/public/images/ic-calendar-clock.ff8c1d7d12889103f17d924f96f51b7e.svg","height":30,"width":30};